// extracted by mini-css-extract-plugin
export default {"price_table":"RhvQ3GBiP5jYoGZX1rST","priceTable":"RhvQ3GBiP5jYoGZX1rST","price_table_supplement":"Ut6jBtIMkGyBgSfSzfzx","priceTableSupplement":"Ut6jBtIMkGyBgSfSzfzx"};